// frontend/src/pages/SupportPage.jsx

import React, { useState } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import './SupportPage.css';

const SupportPage = () => {
  const navigate = useNavigate();
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    subject: '',
    message: '',
    type: 'duvida'
  });
  const [isSubmitted, setIsSubmitted] = useState(false);

  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    // Aqui você implementaria a lógica de envio do formulário
    console.log('Formulário enviado:', formData);
    setIsSubmitted(true);
    
    // Reset após 3 segundos
    setTimeout(() => {
      setIsSubmitted(false);
      setFormData({
        name: '',
        email: '',
        subject: '',
        message: '',
        type: 'duvida'
      });
    }, 3000);
  };

  const faqItems = [
    {
      question: 'Como criar um novo campeonato?',
      answer: 'Acesse o Dashboard, clique em "Campeonatos" e depois em "Novo Campeonato". Preencha todos os dados e clique em salvar.'
    },
    {
      question: 'Como adicionar jogadores a um time?',
      answer: 'Vá até a página do time desejado, clique em "Gerenciar Jogadores" e depois em "Adicionar Jogador".'
    },
    {
      question: 'Como gerar uma súmula?',
      answer: 'Na página da partida, clique no botão "Gerar Súmula" e preencha as informações necessárias.'
    },
    {
      question: 'Quem pode criar times no sistema?',
      answer: 'Usuários com permissões de Admin, Gestor, Técnico, Diretor ou Jogador podem criar novos times.'
    }
  ];

  // Funções para atalhos diretos
  const openWhatsApp = () => {
    const phone = '5566992593031'; // Formato internacional: 55 (Brasil) + DDD + número
    const message = encodeURIComponent('Olá! Preciso de ajuda com o sistema de futebol.');
    window.open(`https://wa.me/${phone}?text=${message}`, '_blank');
  };

  const openEmail = () => {
    const email = 'tvplay544@gmail.com';
    const subject = encodeURIComponent('Suporte - Sistema de Futebol');
    const body = encodeURIComponent('Olá,\n\nPreciso de ajuda com o seguinte:\n\n');
    window.open(`mailto:${email}?subject=${subject}&body=${body}`, '_blank');
  };

  return (
    <div className="support-container">
      <div className="support-header">
        <motion.button
          className="back-button"
          onClick={() => navigate(-1)}
          whileHover={{ scale: 1.05 }}
          whileTap={{ scale: 0.95 }}
        >
          ← Voltar
        </motion.button>
        <motion.h1 
          className="support-title neon-text"
          initial={{ opacity: 0, y: -20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
        >
          Central de Ajuda
        </motion.h1>
        <p className="support-subtitle">
          Estamos aqui para ajudar! Escolha uma opção abaixo ou use nossos canais diretos.
        </p>
      </div>

      {/* NOVOS ATALHOS RÁPIDOS - WHATSAPP E EMAIL */}
      <motion.div 
        className="quick-access"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.1, duration: 0.5 }}
      >
        <h2 className="section-title">Atendimento Rápido</h2>
        <div className="quick-buttons">
          <motion.button
            className="quick-button whatsapp"
            onClick={openWhatsApp}
            whileHover={{ scale: 1.05, boxShadow: '0 0 30px #25D366' }}
            whileTap={{ scale: 0.95 }}
          >
            <span className="quick-icon">📱</span>
            <div className="quick-info">
              <span className="quick-label">WhatsApp</span>
              <span className="quick-value">(66) 99259-3031</span>
            </div>
            <span className="quick-action">Conversar →</span>
          </motion.button>

          <motion.button
            className="quick-button email"
            onClick={openEmail}
            whileHover={{ scale: 1.05, boxShadow: '0 0 30px #EA4335' }}
            whileTap={{ scale: 0.95 }}
          >
            <span className="quick-icon">📧</span>
            <div className="quick-info">
              <span className="quick-label">E-mail</span>
              <span className="quick-value">tvplay544@gmail.com</span>
            </div>
            <span className="quick-action">Enviar →</span>
          </motion.button>
        </div>
      </motion.div>

      <div className="support-content">
        {/* Seção de FAQ */}
        <motion.div 
          className="faq-section"
          initial={{ opacity: 0, x: -20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.2, duration: 0.5 }}
        >
          <h2 className="section-title">Perguntas Frequentes</h2>
          <div className="faq-list">
            {faqItems.map((item, index) => (
              <motion.div 
                key={index}
                className="faq-item"
                initial={{ opacity: 0, y: 20 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ delay: 0.1 * index }}
              >
                <h3 className="faq-question">{item.question}</h3>
                <p className="faq-answer">{item.answer}</p>
              </motion.div>
            ))}
          </div>
        </motion.div>

        {/* Formulário de Contato */}
        <motion.div 
          className="contact-section"
          initial={{ opacity: 0, x: 20 }}
          animate={{ opacity: 1, x: 0 }}
          transition={{ delay: 0.3, duration: 0.5 }}
        >
          <h2 className="section-title">Fale Conosco</h2>
          
          {isSubmitted ? (
            <motion.div 
              className="success-message"
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
            >
              ✅ Mensagem enviada com sucesso! Em breve retornaremos.
            </motion.div>
          ) : (
            <form onSubmit={handleSubmit} className="support-form">
              <div className="form-group">
                <label htmlFor="name">Nome</label>
                <input
                  type="text"
                  id="name"
                  name="name"
                  value={formData.name}
                  onChange={handleChange}
                  required
                  placeholder="Seu nome completo"
                />
              </div>

              <div className="form-group">
                <label htmlFor="email">E-mail</label>
                <input
                  type="email"
                  id="email"
                  name="email"
                  value={formData.email}
                  onChange={handleChange}
                  required
                  placeholder="seu@email.com"
                />
              </div>

              <div className="form-group">
                <label htmlFor="type">Tipo de Solicitação</label>
                <select
                  id="type"
                  name="type"
                  value={formData.type}
                  onChange={handleChange}
                  required
                >
                  <option value="duvida">Dúvida</option>
                  <option value="problema">Problema Técnico</option>
                  <option value="sugestao">Sugestão</option>
                  <option value="outro">Outro</option>
                </select>
              </div>

              <div className="form-group">
                <label htmlFor="subject">Assunto</label>
                <input
                  type="text"
                  id="subject"
                  name="subject"
                  value={formData.subject}
                  onChange={handleChange}
                  required
                  placeholder="Resumo da sua mensagem"
                />
              </div>

              <div className="form-group">
                <label htmlFor="message">Mensagem</label>
                <textarea
                  id="message"
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  required
                  rows="5"
                  placeholder="Descreva sua dúvida ou problema em detalhes..."
                />
              </div>

              <motion.button
                type="submit"
                className="submit-button"
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
              >
                Enviar Mensagem
              </motion.button>
            </form>
          )}
        </motion.div>
      </div>

      {/* Informações de Contato Atualizadas */}
      <motion.div 
        className="contact-info"
        initial={{ opacity: 0, y: 20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ delay: 0.4, duration: 0.5 }}
      >
        <h3>Contato Direto:</h3>
        <div className="contact-methods">
          <motion.div 
            className="contact-method clickable"
            onClick={openWhatsApp}
            whileHover={{ scale: 1.05, backgroundColor: 'rgba(37, 211, 102, 0.2)' }}
          >
            <span className="method-icon">📱</span>
            <div>
              <strong>WhatsApp:</strong>
              <span>(66) 99259-3031</span>
            </div>
          </motion.div>
          
          <motion.div 
            className="contact-method clickable"
            onClick={openEmail}
            whileHover={{ scale: 1.05, backgroundColor: 'rgba(234, 67, 53, 0.2)' }}
          >
            <span className="method-icon">📧</span>
            <div>
              <strong>E-mail:</strong>
              <span>tvplay544@gmail.com</span>
            </div>
          </motion.div>
          
          <div className="contact-method">
            <span className="method-icon">💬</span>
            <div>
              <strong>Chat:</strong>
              <span>Disponível 9h às 18h</span>
            </div>
          </div>
        </div>
      </motion.div>
    </div>
  );
};

export default SupportPage;